// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseBanner_wrapper__e37+1","text":"BaseBanner_text__LQjrp","content":"BaseBanner_content__LKdcC","button":"BaseBanner_button__3q1iK","icon":"BaseBanner_icon__TRjmd"};